import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Template: React.FC = () => {
  return <Outlet />;
};

export default Template;
